import { useRef } from "react";
import { AnimatePresence, motion, useInView } from "framer-motion";
import { LintBubble } from "./LintBubble";

const poses = {
  hero: "/lint_hero.webp",
  sideEye: "/lint_side_eye.webp",
  nod: "/lint_nod.webp",
  deepDive: "/lint_deep_dive.webp",
  laptop: "/lint_laptop.webp",
  books: "/lint_books.webp",
};

export function LintMood({ from, to, alt, say, dark = false, className = "", bubbleClass = "", testId }) {
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.6 });
  const pose = inView ? to : from;
  const line = say ? say[inView ? 1 : 0] : null;

  return (
    <div ref={ref} className="flex flex-col items-center" data-testid={testId} data-pose={pose}>
      {line && (
        <LintBubble dark={dark} className={`mb-5 ${bubbleClass}`} testId={testId && `${testId}-bubble`}>
          <AnimatePresence mode="wait" initial={false}>
            <motion.span
              key={line}
              initial={{ opacity: 0, y: 4 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.25 }}
              className="block"
            >
              {line}
            </motion.span>
          </AnimatePresence>
        </LintBubble>
      )}
      <div className={`relative ${className}`}>
        <img src={poses[from]} alt="" aria-hidden className="invisible w-full" />
        <AnimatePresence initial={false}>
          <motion.img
            key={pose}
            src={poses[pose]}
            alt={alt}
            initial={{ opacity: 0, scale: 0.94, rotate: -3 }}
            animate={{ opacity: 1, scale: 1, rotate: 0, transition: { duration: 0.45, delay: inView ? 0.3 : 0 } }}
            exit={{ opacity: 0, scale: 0.96, transition: { duration: 0.25 } }}
            className="absolute inset-0 h-full w-full object-contain"
            draggable={false}
          />
        </AnimatePresence>
      </div>
    </div>
  );
}
